import { WecomUnreadNumUpdateData } from "../../handler/wecom/ws-types";
import EventBus from "../event-bus";
const unreadNumUpdateHook = new EventBus<WecomUnreadNumUpdateData>(
  "unreadNumUpdateHook"
);

export default unreadNumUpdateHook;
